import apis from 'SERVICE/APIs';
// ================================
// Action Type
// ================================
const FETCH_PROVINCEANDCITY = 'FETCH_PROVINCEANDCITY'; // 查询省市
const FETCH_BRANCH = 'FETCH_BRANCH'; // 查询银行卡列表
const VERIFY_AUTHCODE = 'VERIFY_AUTHCODE';
const SEND_SMS = 'SEND_SMS';
const VERIFY_CODE = 'VERIFY_CODE';
const INPUT_MOBILE = 'INPUT_MOBILE';
const CHECK_CARDNOMOBILE = 'CHECK_CARDNOMOBILE';
const GET_COMMONURL = 'GET_COMMONURL';
const GET_MEMBERTYPE = 'GET_MEMBERTYPE';
const SEND_SMS_CAPTCHA = 'SEND_SMS_CAPTCHA';
const PRE_CHECK_CAPTCHA_CODE = 'PRE_CHECK_CAPTCHA_CODE';


// ================================
// Action Creator
// ================================

const fetchProvinceAndCity = params => dispatch => apis.Common.QueryAllProvCities(params)
  .then((msgs) => {
    dispatch({
      type: FETCH_PROVINCEANDCITY,
      payload: msgs,
    });
    return msgs;
  });

const sendSms = params => dispatch => apis.Fund.SendSMS(params).then((msgs) => {
  dispatch({
    type: SEND_SMS,
    payload: msgs,
  });
  return msgs;
});

const sendSMSCaptcha = params => dispatch => apis.Fund.SendSMSCaptcha(params).then((msgs) => {
  dispatch({
    type: SEND_SMS_CAPTCHA,
    payload: msgs,
  });
  return msgs;
});

const preCheckCaptchaCode = params => dispatch => apis.Common.PreCheckCaptchaCode(params).then((msgs) => {
  dispatch({
    type: PRE_CHECK_CAPTCHA_CODE,
    payload: msgs,
  });
  return msgs;
});


const verifyCode = params => dispatch => apis.Fund.CheckVerifyCode(params).then((msgs) => {
  dispatch({
    type: VERIFY_CODE,
    payload: msgs,
  });
  return msgs;
});

const fetchBranch = params => dispatch => apis.Common.QueryBranches(params).then((msgs) => {
  dispatch({
    type: FETCH_BRANCH,
    payload: msgs,
  });
  return msgs;
});

const verifyAuthCode = params => dispatch => apis.Wallet.VerifyAuthCode(params).then((msgs) => {
  dispatch({
    type: VERIFY_AUTHCODE,
    payload: msgs,
  });
  return msgs;
});

const inputMobile = params => dispatch => apis.Wallet.InputMobile(params).then((msgs) => {
  dispatch({
    type: INPUT_MOBILE,
    payload: msgs,
  });
  return msgs;
});

const checkCardNoMobile = params => dispatch => apis.Common.CheckCardNoMobile(params)
  .then((msgs) => {
    dispatch({
      type: CHECK_CARDNOMOBILE,
      payload: msgs,
    });
    return msgs;
  });

const getCommonUrl = params => dispatch => apis.Common.GetCommonUrl(params).then((msgs) => {
  dispatch({
    type: GET_COMMONURL,
    payload: msgs,
  });
  return msgs;
});

const getMemberType = params => dispatch => apis.Wechat.GetMemberTypeAndOperators(params)
  .then((msgs) => {
    dispatch({
      type: GET_MEMBERTYPE,
      payload: msgs,
    });
    return msgs;
  });

/* default 导出所有 Action Creators */
export default {
  fetchProvinceAndCity,
  fetchBranch,
  verifyAuthCode,
  sendSms,
  inputMobile,
  checkCardNoMobile,
  getCommonUrl,
  getMemberType,
  verifyCode,
  sendSMSCaptcha,
  preCheckCaptchaCode,
};

// ================================
// Action handlers for Reducer
// 本来更新 state 是 Reducer 的责任
// 但要把 ActionType 导出又引入实在太麻烦
// 且在 Reducer 中写 switch-case 实在太不优雅
// 故在此直接给出处理逻辑
// ================================
export const ACTION_HANDLERS = {
  [FETCH_PROVINCEANDCITY]: (result, { payload }) => ({ payload }),
  [FETCH_BRANCH]: (result, { payload }) => ({ payload }),
  [VERIFY_AUTHCODE]: (result, { payload }) => ({ payload }),
  [SEND_SMS]: (result, { payload }) => ({ payload }),
  [VERIFY_CODE]: (result, { payload }) => ({ payload }),
  [INPUT_MOBILE]: (result, { payload }) => ({ payload }),
  [CHECK_CARDNOMOBILE]: (result, { payload }) => ({ payload }),
  [GET_COMMONURL]: (result, { payload }) => ({ payload }),
  [GET_MEMBERTYPE]: (result, { payload }) => ({ payload }),
  [SEND_SMS_CAPTCHA]: (result, { payload }) => ({ payload }),
  [PRE_CHECK_CAPTCHA_CODE]: (result, { payload }) => ({ payload }),
};



// WEBPACK FOOTER //
// ./src/redux/actions/common/commonAction.js